import type { ILink } from "@components/core/Link";

import { Link } from "@components/core/Link";
import { cn } from "@ui/lib/utils";

export default function HeadingWithLink({
  inverse = false,
  headerLink,
  titlePrefix,
  className,
}: {
  className?: string;
  headerLink: ILink | null;
  inverse?: boolean;
  titlePrefix: string;
}) {
  return (
    <div className={cn("mx-16 mb-24 flex items-baseline gap-4 lg:mx-0", className)}>
      <span className={cn("f-ui-02 font-light normal-case", inverse && "text-inverse")}>{titlePrefix}</span>
      {headerLink && <Link {...headerLink} className='underline decoration-dotted' inverse={inverse} size='lg' />}
    </div>
  );
}
